import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import CustomTooltip from "./CustomTooltip";
import { renderToStaticMarkup } from "react-dom/server";
import { Spin, Typography } from "antd";

const ApexChart = ({ dataRevenueByKAM, formatCurrency, loading }) => {
  const categories = dataRevenueByKAM.map(item => item.tenKAM);
  const series = [
    {
      name: "Doanh số",
      type: "column",
      data: dataRevenueByKAM.map(item => item.doanhSo),
    },
    {
      name: "Target",
      type: "column",
      data: dataRevenueByKAM.map(item => item.target),
    },
    {
      name: "%DS/TG",
      type: "line",
      data: dataRevenueByKAM.map(item =>
        item.target ? ((item.doanhSo * 100) / item.target).toFixed(2) : 0
      ),
    },
  ];
  const findMaxValue = () => {
    const columnSeries = series.filter(item => item.type === "column");
    const tatDataArray = columnSeries.map(item => item.data).flat();
    const maxValue = Math.max(...tatDataArray);
    return maxValue;
  };

  const maxValue = findMaxValue();
  const options = {
    chart: {
      height: 350,
      type: "line",
      stacked: false,
      toolbar: {
        show: false, // Hide the toolbar
      },
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [2],
      formatter: value => {
        return `${value}%`;
      },
    },
    stroke: {
      width: [1, 1, 4],
    },
    xaxis: {
      categories: categories,
    },
    yaxis: [
      {
        seriesName: "Doanh số",
        min: 0,
        max: maxValue,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#008FFB",
        },
        labels: {
          style: {
            colors: "#008FFB",
          },
          show: true,
          formatter: function (value) {
            const valueInBillions = value / 1e9;
            return formatCurrency(valueInBillions) + " Tỷ";
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      {
        min: 0,
        max: maxValue,
        show: false,
        seriesName: "Target",
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#00E396",
        },
        labels: {
          style: {
            colors: "#00E396",
          },
          show: true,
          formatter: function (value) {
            return formatCurrency(value);
          },
        },
      },
      {
        seriesName: "%DS/TG",
        opposite: true,
        axisTicks: {
          show: true,
        },
        axisBorder: {
          show: true,
          color: "#FEB019",
        },
        labels: {
          style: {
            colors: "#FEB019",
          },
          show: true,
          formatter: function (value) {
            return value + "%";
          },
        },
      },
    ],
    tooltip: {
      custom: function ({ dataPointIndex, w }) {
        const data = w.globals.initialSeries;
        const tooltipItems = data.map((el, idx) => ({
          id: idx,
          name: el.name,
          value: el.data[dataPointIndex],
          color: w.globals.colors[idx],
        }));
        const result = tooltipItems.map(el => {
          let formattedValue;

          // Định dạng giá trị dựa trên tên
          switch (el.name) {
            case "Doanh số":
              formattedValue = formatCurrency(el.value) + " VNĐ"; // Thêm đơn vị VND
              break;
            case "Target":
              formattedValue = formatCurrency(el.value) + " VNĐ"; // Thêm đơn vị Target
              break;
            case "%DS/TG":
              formattedValue = el.value + "%"; // Thêm ký hiệu phần trăm
              break;
            default:
              formattedValue = el.value; // Không thêm đơn vị cho các trường hợp khác
          }

          return {
            ...el,
            value: formattedValue,
          };
        });
        return renderToStaticMarkup(
          <CustomTooltip
            title={`${categories[dataPointIndex]}`}
            data={result}
          />
        );
      },
    },
    legend: {
      horizontalAlign: "center",
      style: {
        fontSize: "20px",
      },
    },
    noData: {
      text: "Không có dữ liệu",
    },
  };

  return (
    <div>
      {loading ? (
        <Spin tip="Loading...">
          <div style={{ height: 389 }} />
        </Spin>
      ) : (
        <>
          <Typography.Title
            className="text-center"
            style={{ fontWeight: "bold", marginBottom: 0, fontSize: "20px" }}
          >
            Doanh thu theo nhân viên
          </Typography.Title>
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="line"
              height={350}
            />
          </div>
        </>
      )}

      <div id="html-dist"></div>
    </div>
  );
};

export default ApexChart;
